import React from 'react';

import withCard from './WithCard';
import YesNo from '../../../Types/Components/YesNo';

const YesNoCard = (props) => {
  return <YesNo {...props} />
}

export default withCard(YesNoCard);